<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'setting'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Manage Profile</h1>
						</div>
						<div class="form-container">
							<form @submit.prevent="saveSettings">
								<!-- Basic Info Section -->
								<div class="form-section">
									<h3 class="section-title">Basic Info</h3>

									<!-- Shop Name -->
									<div class="form-item">
										<label class="form-label required">Your name</label>
										<input v-model="formBase.fullName" type="text" class="form-input"
											placeholder="Your name" required />
									</div>

									<div class="form-item">
										<label class="form-label required">Your Phone</label>
										<input v-model="formBase.storePhone" type="text" class="form-input"
											placeholder="Your Phone" required />
									</div>

									<!-- Shop Logo -->
									<div class="form-item">
										<label class="form-label">Photo</label>
										<div class="logo-upload-container">
											<div v-if="!formBase.storeHead" class="upload-placeholder">
												<input type="file" accept="image/*" @change="handleLogoUpload"
													style="position: absolute; opacity: 0; width: 100%; height: 100%; cursor: pointer;" />
												<span>+</span>
											</div>
											<img v-else :src="formBase.storeHead" alt="Photo" class="uploaded-logo" />
										</div>
									</div>

									<!-- Shop Phone -->
									<div class="form-item">
										<label class="form-label">Your Password</label>
										<input v-model="formBase.password" type="tel" class="form-input"
											placeholder="New Password" />
									</div>


									<!-- Shop Address -->
									<div class="form-item">
										<label class="form-label required">Confirm Password</label>
										<input v-model="formBase.confirmPassword" type="text" class="form-input"
											placeholder="Confirm Password" required />
									</div>

									<!-- Save Button -->
									<div class="form-actions">
										<button type="button" class="btn-save" @click="handleBase">Save</button>
									</div>
								</div>
							</form>
						</div>

						<div class="form-container" style="margin-top: 20px;">

							<!-- Basic Info Section -->
							<div class="form-section">
								<div>Payment setting</div>
								<h3 class="section-title">Bank Payment</h3>
								<!-- Shop Name -->
								<div class="form-item">
									<label class="form-label required">Bank Name</label>
									<input v-model="formAccount.bankName" type="text" class="form-input"
										placeholder="Bank Name" required />
								</div>

								<div class="form-item">
									<label class="form-label required">Bank Account Name</label>
									<input v-model="formAccount.accountName" type="text" class="form-input"
										placeholder="Bank Account Name" required />
								</div>


								<!-- Shop Phone -->
								<div class="form-item">
									<label class="form-label">Bank Account Number</label>
									<input v-model="formAccount.accountNumber" type="tel" class="form-input"
										placeholder="Bank Account Number" />
								</div>


								<!-- Shop Address -->
								<div class="form-item">
									<label class="form-label required">Bank Routing Number</label>
									<input v-model="formAccount.routingNumber" type="text" class="form-input"
										placeholder="Bank Routing Number" required />
								</div>
								<h3 class="section-title">USDT Payment</h3>
								<!-- Shop Name -->
								<div class="form-item">
									<label class="form-label required">USDT Address</label>
									<input v-model="formAccount.usdtAddress" type="text" class="form-input"
										placeholder="USDT Address" required />
								</div>
								<!-- Save Button -->
								<div class="form-actions">
									<button type="button" class="btn-save" @click="handleAccount">Save</button>
								</div>
							</div>


						</div>

						<div class="form-container" style="margin-top: 20px;">

							<!-- Basic Info Section -->
							<div class="form-section">
								<h3 class="section-title">Change your email</h3>

								<!-- Shop Phone -->
								<div class="form-item">
									<label class="form-label">Your Email</label>
									<div style="display: flex;">
										<input v-model="formEmail.email" type="tel" class="form-input"
											placeholder="Your Email" />
										<button @click="sendCode" :disabled="countdown > 0" style="cursor: pointer">
											{{ countdown > 0 ? `${countdown}s` : 'send' }}
										</button>
									</div>
								</div>

								<!-- Introduction -->
								<div class="form-item">
									<label class="form-label">Verification Code</label>

									<input v-model="formEmail.verifyCode" type="text" class="form-input"
										placeholder="Verification Code" required />

								</div>

								<!-- Save Button -->
								<div class="form-actions">
									<button type="button" @click="handleEmail" class="btn-save">Save</button>
								</div>
							</div>

						</div>


					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		storeDetail,
		updateStoreEmail,
		updateStoreAccount,
		updateStoreInfo,
		uploadFile
	} from '../../api/home.js'
	import {
		sendVerifyCode
	} from '../../api/api.js'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				selectedFile: null,
				formBase: {
					fullName: null,
					storeHead: null,
					storePhone: null,
					password: null,
					confirmPassword: null
				},
				formAccount: {
					bankName: null,
					accountName: null,
					accountNumber: null,
					routingNumber: null,
					usdtAddress: null
				},
				formEmail: {
					email: null,
					verifyCode: null
				},
				tableLoading: false,
				countdown: 0,
				countdownInterval: null
			}
		},
		created() {
			this.getStoreDetail();
		},
		beforeDestroy() {
			// Clean up interval when component is destroyed
			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
			}
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			handleLogoUpload(event) {
				this.selectedFile = event.target.files[0];
				this.uploadPhoto()
			},
			// 修改 uploadPhoto 方法
			uploadPhoto() {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile, this.selectedFile.name);
				let file = formData
				uploadFile(file).then(res => {
					if (res.code == 200) {
						// 假设接口返回的文件URL在 res.data.url 中
						this.formBase.storeHead = res.url;
						this.$message.success('Image uploaded successfully');
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(res.msg || 'Image upload failed');
				});
			},
			sendCode() {
				if (!this.formEmail.email) {
					this.$message.error('Please enter your email')
					return
				}
				if (this.countdown > 0) return;
				sendVerifyCode({
					email: this.formEmail.email
				}).then(res => {
					if (res.code == 200) {
						this.$message.success('Send verification code success')
						this.startCountdown()
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			startCountdown() {
				this.countdown = 60; // 1 minute

				// Clear any existing interval
				if (this.countdownInterval) {
					clearInterval(this.countdownInterval);
				}

				// Start new countdown
				this.countdownInterval = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						clearInterval(this.countdownInterval);
						this.countdownInterval = null;
					}
				}, 1000);
			},
			triggerFileInput() {
				this.$refs.logoInput.click();
			},
			handleEmail() {
				if (!this.formEmail.email) {
					this.$message.error('Please enter your email')
					return
				}
				if (!this.formEmail.verifyCode) {
					this.$message.error('Please enter the verification code')
					return
				}
				updateStoreEmail(this.formEmail).then(res => {
					if (res.code == 200) {
						this.$message.success('Update store email success')
						this.getStoreDetail();
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			handleAccount() {
				/*if(!this.formAccount.bankName){
				  this.$message.error('Please enter the bank name')
				  return
				}
				if(!this.formAccount.accountName){
				  this.$message.error('Please enter the account name')
				  return
				}
				if(!this.formAccount.accountNumber){
				  this.$message.error('Please enter the account number')
				  return
				}
				if(!this.formAccount.routingNumber){
				  this.$message.error('Please enter the routing number')
				  return
				}
				if(!this.formAccount.usdtAddress){
				  this.$message.error('Please enter the usdt address')
				  return
				}*/

				updateStoreAccount(this.formAccount).then(res => {
					if (res.code == 200) {
						this.$message.success('Update store account success')
						this.getStoreDetail();
					} else {
						this.$message.error(res.msg)
					}
				})
			},

			handleBase() {

				/* if(!this.formBase.fullName){
           this.$message.error('Please enter the full name')
           return
         }
       if(!this.formBase.storePhone){
           this.$message.error('Please enter the store phone')
           return
         }
         if(!this.formBase.password){
           this.$message.error('Please enter the password')
           return
         }
         if(!this.formBase.confirmPassword){
           this.$message.error('Please enter the confirm password')
           return
         }*/
				updateStoreInfo(this.formBase).then(res => {
					if (res.code == 200) {
						this.$message.success('Update store base info success')
						this.getStoreDetail();
					}
				})
			},
			getStoreDetail() {
				storeDetail().then(res => {
					if (res.code == 200) {
						this.formAccount.bankName = res.data.bankName
						this.formAccount.accountName = res.data.accountName
						this.formAccount.accountNumber = res.data.accountNumber
						this.formAccount.routingNumber = res.data.routingNumber
						this.formAccount.usdtAddress = res.data.usdtAddress
						this.formEmail.email = res.data.email
						this.formBase.fullName = res.data.fullName
						this.formBase.storePhone = res.data.storePhone
						this.formBase.storeHead = res.data.storeHead

					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
</style>
<style scoped>
	.form-container {
		max-width: 100%;
		padding: 20px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.form-section {
		margin-bottom: 20px;
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-bottom: 15px;
	}

	.form-item {
		margin-bottom: 15px;
	}

	.form-label {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #555;
		margin-bottom: 8px;
	}

	.required::after {
		content: " *";
		color: red;
	}

	.form-input,
	.form-textarea {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
	}

	.form-textarea {
		resize: vertical;
	}

	.logo-upload-container {
		position: relative;
		width: 100px;
		height: 100px;
		border: 2px dashed #007bff;
		border-radius: 4px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.upload-placeholder {
		width: 100%;
		height: 100%;
		background-color: #f8f9fa;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #007bff;
		cursor: pointer;
	}

	.uploaded-logo {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	.form-actions {
		text-align: right;
		margin-top: 20px;
	}

	.btn-save {
		background-color: #007bff;
		color: white;
		padding: 10px 20px;
		border: none;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
	}

	.btn-save:hover {
		background-color: #0056b3;
	}

	/* 移动端适配 */
	@media (max-width: 768px) {
		.form-container {
			padding: 15px;
		}

		.form-item {
			margin-bottom: 12px;
		}

		.logo-upload-container {
			width: 80px;
			height: 80px;
		}

		.form-input,
		.form-textarea {
			font-size: 13px;
		}

		.btn-save {
			padding: 8px 16px;
			font-size: 13px;
		}
	}
</style>
